<div class="container">
  <button mat-stroked-button routerLink="">
    <mat-icon fontIcon="arrow_back"/>
    Return to Dashboard
  </button>
  <h1>About</h1>
  <p>
    This is a simple web app that allows Tesla drivers to easily access fullscreen media in their cars while parked.
    Normally, doing this is a complicated process that is harder than it needs to be.
    Testube makes the process as easy as possible, ensuring you get to your media quickly.
  </p>
  <p>
    To use the application in fullscreen, simply press the "Open in Fullscreen" button at the bottom of the page.
    If you are already in fullscreen, you will not see that button. Do note that your car <b>must</b> be in Park for
    this to work.
  </p>
  <p>
    We hope to add more services and features as time goes on to further improve the user experience.
    If a service does not work on your Tesla, that is not within our control.
  </p>
  <h1>Disclaimer</h1>
  <p>
    This product is not in any way related to the Tesla brand or any of the other brands displayed within.
    Navigating to each service brings you to their official application served securely over HTTPS.
    None of your information is stored by this application. This application is served securely through SSL on HTTPS,
    and all traffic is encrypted.
  </p>
</div>